export default "__VITE_ASSET__DYx0vFkN__"